import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { CarouselsList } from './components/CarouselsList';
import { CarouselForm } from './components/CarouselForm';
import SingleCarousel from './single';

const CarouselsRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<CarouselsList />} />
      <Route path='create' element={<CarouselForm />} />
      <Route path='edit/:id' element={<CarouselForm />} />
      <Route path=':id' element={<SingleCarousel />} />
      <Route path='*' element={<Navigate to='/' replace />} />
    </Routes>
  );
};

export default CarouselsRoutes;
